<template>
  <LuJhu lu-jhu-type="BoSeLuJhu" />
</template>

<script>
import LuJhu from '@/components/desktop/common/trend/LuJhu'
export default {
  name: 'BoSe',
  components: {
    LuJhu
  }
}
</script>
